import Vue from 'vue'
import enums from 'vue-enums'

// use enums directly in template
Vue.use(enums)